import { useEffect, useState } from "react";
import {
  TextField,
  IconButton,
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TablePagination,
  Box,
} from "@mui/material";

import {
  addTemplateList,
  ArchiveTemplate,
  getTemplateList,
} from "../../Services/TemplateApi";
import { ReactComponent as SearchIcon } from "../../Assets/Search.svg";
import { ReactComponent as FilterIcon } from "../../Assets/filter.svg";
import { ReactComponent as TimeIcon } from "../../Assets/time.svg";
import { ReactComponent as UserIcon } from "../../Assets/cardUser.svg";
import { ReactComponent as EditedIcon } from "../../Assets/EditIcon.svg";
import { ReactComponent as DeletedIcon } from "../../Assets/delete.svg";
import { ReactComponent as AddIcon } from "../../Assets/add.svg";
import { ReactComponent as GridViewIcon } from "../../Assets/Gridview.svg";
import { ReactComponent as ListViewIcon } from "../../Assets/Listview.svg";
import { Search } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import defaultLogo from "../../Assets/defaultLogo.svg";
import Tooltip from "@mui/material/Tooltip";
const useCases = [
  { label: "Select Use case", value: "Select Use case" },
  { label: "Metering", value: "metering" },
  { label: "Lightbox", value: "lightbox" },
];

const validationSchema = Yup.object({
  title: Yup.string().required("Title is Required"),
  useCase: Yup.string()
    .test(
      "is-not-default",
      "Use Case is required",
      (value) => value !== "Select Use case"
    )
    .required("Use Case is required"),
  description: Yup.string().optional(),
});

const Template = () => {
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState(() => {
    return localStorage.getItem("sortOrder") || "all";
  });

  const [statusFilter, setStatusFilter] = useState(() => {
    return localStorage.getItem("statusFilter") || "all";
  });
  const [templates, setTemplates] = useState([]);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Items per page
  const navigate = useNavigate();
  const [openArchivePopup, setOpenArchivePopup] = useState(false);
  const [viewMode, setViewMode] = useState<any>("grid");
  const [title, setTitle] = useState("");
  const [comment, setComment] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [status, setStatus] = useState<number | null>(null);

  const fetchTemplates = async (
    name: string,
    sortOrder: string,
    statusFilter: string,
    page: number,
    rowsPerPage: number
  ) => {
    setLoading(true);
    try {
      const response = await getTemplateList(
        name,
        sortOrder,
        statusFilter,
        page + 1,
        rowsPerPage
      );
      if (response.success === true) {
        setTemplates(response.templates);
        setTotalTemplates(response.totalTemplates);
        setTotalPages(response.totalPage);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTemplates(title, sortOrder, statusFilter, page, rowsPerPage);
  }, [title, sortOrder, statusFilter, page, rowsPerPage]);

  const formik = useFormik({
    initialValues: {
      title: "",
      useCase: "Select Use case",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const response = await addTemplateList(
          values.title,
          values.useCase,
          values.description,
          status
        );
        if (response.success === true) {
          toast.success(response.message);
          formik.resetForm();
          setOpen(false);
          fetchTemplates(search, sortOrder, statusFilter, page, rowsPerPage);
        }
      } catch (error: any) {
        console.error(
          "Error adding template:",
          error.response?.data || error.message
        );
      } finally {
        setLoading(false);
      }
    },
  });

  const handleEdit = (template: any) => {
    navigate(`/edit-template/${template.id}`, { state: { template } });
  };
  const handleArchieve = (template: any) => {
    setSelectedTemplate(template);
    setOpenArchivePopup(true);
  };

  const handleClose = () => {
    setOpenArchivePopup(false);
    setComment("");
  };

  const handleArchive = async (template: any) => {
    try {
      const response = await ArchiveTemplate(template.id, template.status);
      if (response.success === true) {
        toast.success(response.message);
        fetchTemplates(search, sortOrder, statusFilter, page, rowsPerPage);
      } else {
        toast.error("Failed to archive template!");
      }
      handleClose();
    } catch (error) {
      console.error("Error deleting template:", error);
    }
  };
  const handleSearchChange = (e: any) => {
    setSearch(e.target.value);
  };
  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = () => {
    if (search === "") {
      setTitle("");
    }
    setTitle(search);
    setPage(0);
  };
  const processHtml = (htmlContent: any) => {
    if (!htmlContent || typeof htmlContent !== "string") {
      return "";
    }
    const scriptRegex = /<div custom-script>([\s\S]*?)<\/div>/g;
    let scripts = "";
    let processedHtml = htmlContent.replace(
      scriptRegex,
      (scriptContent: any) => {
        scripts += `<script>${scriptContent}</script>`;
        return "";
      }
    );

    const generateCaptcha = () => {
      const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let captcha = "";
      for (let i = 0; i < 6; i++) {
        captcha += chars[Math.floor(Math.random() * chars.length)];
      }
      return captcha;
    };
    if (processedHtml.includes('id="image-captcha"')) {
      const captchaCode = generateCaptcha();
      processedHtml = processedHtml.replace(
        '<div id="image-captcha"></div>',
        `<div id="image-captcha">${captchaCode}</div>`
      );
    }
    return processedHtml + scripts;
  };
  const handleSortChange = (e: any) => {
    const value = e.target.value;
    setSortOrder(value);
    localStorage.setItem("sortOrder", value);
  };
  const handleStatusFilterChange = (e: any) => {
    const value = e.target.value;
    setStatusFilter(value);
    localStorage.setItem("statusFilter", value);
  };

  return (
    <div className="templates">
      <Grid container className="templates__header">
        <Grid
          size={{ xs: 12, md: 3, sm: 12 }}
          className="templates__header--search"
        >
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Search..."
            size="small"
            value={search}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            InputProps={{
              startAdornment: (
                <IconButton>
                  <Search />
                </IconButton>
              ),
            }}
          />
        </Grid>
        {/* Sort Dropdown */}

        <Grid
          size={{ xs: 12, md: 4, sm: 4 }}
          className="templates__header--filter text-center"
        >
          <span className="label--filter">Usecase : </span>
          <TextField
            select
            size="small"
            value={sortOrder}
            onChange={handleSortChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FilterIcon />
                </InputAdornment>
              ),
            }}
            style={{ flex: 1 }}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="metering">Metering System</MenuItem>
            <MenuItem value="lightbox">Lightbox</MenuItem>
          </TextField>
        </Grid>
        <Grid
          size={{ xs: 12, md: 3, sm: 4 }}
          className="templates__header--pagination br-1 text-center"
        >
          {/* Pagination */}
          <TablePagination
            component="div"
            count={totalTemplates} // Total number of templates
            page={page} // Current page index
            rowsPerPage={rowsPerPage} // Number of items per page
            onPageChange={(_, newPage) => {
              if (newPage < totalPages) {
                setPage(newPage);
              }
            }}
            rowsPerPageOptions={[5, 10, 25]} // Page size options
            onRowsPerPageChange={(e) => {
              const newRowsPerPage = parseInt(e.target.value, 10);
              setRowsPerPage(newRowsPerPage);
              setPage(0); // Reset to first page when changing rows per page
            }}
            sx={{
              "& .MuiTablePagination-toolbar": {
                minHeight: "auto",
              },
              "& .MuiTablePagination-selectLabel": {
                display: "none",
              },
              "& .MuiTablePagination-select": {
                display: "none",
              },
              "& .MuiTablePagination-spacer": {
                display: "none",
              },
            }}
          />
        </Grid>
        {/* <Grid size={{ xs: 12, md: 2 }} className=" br-1 text-center">
         
         
        </Grid> */}
        <Grid
          size={{ md: 2, sm: 4, xs: 12 }}
          className="templates__header--button"
        >
          {/* Add Template Button */}
          <Button
            variant="contained"
            color="error"
            onClick={() => setOpen(true)}
            sx={{
              "--variant-containedBg": "rgba(228, 0, 43, 1)",
            }}
          >
            Add Template
          </Button>
        </Grid>
      </Grid>
      <div>
        <Dialog
          className="modal"
          open={open}
          onClose={() => setOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <h2 className="mb-0">
            {" "}
            <span className="Icon">
              <AddIcon />{" "}
            </span>{" "}
            Add template
          </h2>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <form onSubmit={formik.handleSubmit}>
            <DialogContent className="modal-content">
              <label>
                Title of template <span style={{ color: "red" }}>*</span>
              </label>
              {/* Title Field */}
              <TextField
                placeholder="Enter title of template"
                name="title"
                fullWidth
                variant="filled"
                value={formik.values.title}
                error={formik.touched.title && Boolean(formik.errors.title)}
                helperText={formik.touched.title && formik.errors.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              {/* Use Case Dropdown */}
              <label>
                Use case <span style={{ color: "red" }}>*</span>
              </label>
              <TextField
                select
                name="useCase"
                variant="filled"
                value={
                  formik.values.useCase !== undefined
                    ? formik.values.useCase
                    : ""
                }
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.useCase && Boolean(formik.errors.useCase)}
                helperText={formik.touched.useCase && formik.errors.useCase}
              >
                {useCases.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    disabled={option.value === "Select useCase"}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              {/* Description Field */}
              <label>Description</label>
              <TextField
                className="mb-0 "
                placeholder="Enter description"
                name="description"
                fullWidth
                multiline
                rows={3}
                value={formik.values.description}
                margin="normal"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
              />
            </DialogContent>

            {/* Action Buttons */}
            <DialogActions disableSpacing className="modal_footer--button">
              <Button
                className="button"
                variant="outlined"
                color="primary"
                disabled={loading}
                onClick={() => {
                  setStatus(0); // Draft
                  formik.handleSubmit();
                }}
                sx={{
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",

                  "&:hover": {
                    "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                    "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                    "--variant-containedBg": "rgba(228, 0, 43, 1)",
                    "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                  },
                }}
              >
                Save as Draft
              </Button>
              <Button
                className="button"
                type="button"
                variant="contained"
                color="error"
                disabled={loading}
                sx={{
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                }}
                onClick={() => {
                  setStatus(1); // Publish
                  formik.handleSubmit();
                }}
              >
                {loading ? <span className="loader" /> : "Add Template"}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>

      {/* Template List */}

      <Grid container spacing={2} mb={2}>
        <Grid
          size={{ xs: 12, md: 12 }}
          sx={{
            alignItems: "flex-end",
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
          }}
        >
          <div>
            <span className="label--filter">Status</span>
            <TextField
              className="custom-filter"
              sx={{
                background: "#fffff",
                boxShadow: "0px 4px 60px 0px rgba(0, 0, 0, 0.07)",
              }}
              select
              size="small"
              value={statusFilter}
              onChange={handleStatusFilterChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FilterIcon />
                  </InputAdornment>
                ),
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="0">Draft</MenuItem>
              <MenuItem value="1">Published</MenuItem>
              <MenuItem value="2">Archived</MenuItem>
            </TextField>
          </div>
          <div className="templates__header--viewMode">
            <Tooltip title="Grid View" placement="top" arrow>
              <IconButton
                onClick={() => setViewMode("grid")}
                className={viewMode === "grid" ? "active" : ""}
              >
                <GridViewIcon
                  color={viewMode === "grid" ? "error" : "inherit"}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="List View" placement="top" arrow>
              <IconButton
                className={viewMode === "list" ? "active" : ""}
                onClick={() => setViewMode("list")}
              >
                <ListViewIcon
                  color={viewMode === "list" ? "error" : "inherit"}
                />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {templates.map((template: any) => (
          <Grid
            size={{
              xs: 12,
              sm: viewMode === "grid" ? 6 : 12,
              md: viewMode === "grid" ? 4 : 12,
            }}
            spacing={2}
            className={`templates__grid ${
              viewMode === "list" ? "templates__grid--list" : ""
            }`}
            key={template.id}
          >
            {viewMode === "grid" ? (
              <div className="templates__grid-card">
                <div className="templates__grid-image">
                  {template.html ? (
                    <iframe
                      title={template.title}
                      srcDoc={`<!DOCTYPE html>
                <html style =" 
                  overflow: hidden;">
                  <head>
                    <style>
                      ${template.css}
                      .ng-hide {
                        display: none !important;
                      }
                         .cross-icon {
                        display: none !important;
                      }
                        .down-arrow-img{
                        display: none !important;
                        }
                      /* Disable all interactions */
                      body {
                        pointer-events: none;
                        user-select: none;
                      }

                      input, textarea, select, button {
                        pointer-events: none !important;
                        background-color: #f0f0f0 !important;
                        color: #666 !important;
                        cursor: not-allowed !important;
                      }

                      label {
                        color: #999 !important;
                      }
                    </style>
                  </head>
                  <body class="tn-lightbox">
                     ${processHtml(template.html)}
                  </body>
                </html>`}
                      className={defaultLogo ? "centered-logo" : ""}
                      style={{ width: "100%", height: "600px", border: "none" }}
                    ></iframe>
                  ) : (
                    <img
                      src={defaultLogo}
                      className={defaultLogo ? "centered-logo" : ""}
                      alt={template.title}
                    />
                  )}
                </div>
                <div className="templates__grid-info">
                  <h3>{template.title}</h3>
                  <div className="templates__grid-meta">
                    <div>
                      <p>
                        <span className="Icon">
                          <TimeIcon />
                        </span>
                        {new Date(template.createdAt).toLocaleString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "2-digit",
                        })}{" "}
                        -{" "}
                        {new Date(template.createdAt).toLocaleString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",

                          hour12: true,
                        })}
                      </p>
                      <p>
                        <span className="Icon">
                          <UserIcon />
                        </span>
                        {template.updated_by
                          ?.toLowerCase()
                          .split(" ")
                          .map(
                            (word: any) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")}
                      </p>
                    </div>
                    <div className="templates__grid-button">
                      <Tooltip title="Edit" placement="top" arrow>
                        <IconButton
                          className="EditedIcon"
                          onClick={() => handleEdit(template)}
                        >
                          {" "}
                          <EditedIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Archived" placement="top" arrow>
                        <IconButton
                          className="ArchiveOutlinedIcon"
                          onClick={() => handleArchieve(template)}
                        >
                          {" "}
                          <ArchiveOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Box className="templates__grid">
                <Grid
                  container
                  key={template.id}
                  flex={1}
                  className="templates__list-card"
                  spacing={2}
                >
                  <Grid size={{ xs: 12, md: 4 }}>
                    <div className="templates__list-image">
                      {template.html ? (
                        <iframe
                          title={template.title}
                          srcDoc={`<!DOCTYPE html>
                <html  style =" 
                  overflow: hidden;">
                  <head>
                    <style>
                      ${template.css}
                      .ng-hide {
                        display: none !important;
                      }
                      .cross-icon {
                        display: none !important;
                      }
                      body {
                        pointer-events: none;
                        user-select: none;
                      }

                      input, textarea, select, button {
                        pointer-events: none !important;
                        background-color: #f0f0f0 !important;
                        color: #666 !important;
                        cursor: not-allowed !important;
                      }

                      label {
                        color: #999 !important;
                      }
                    </style>
                  </head>
                  <body>
                    ${processHtml(template.html)}
                  </body>
                </html>`}
                          className={defaultLogo ? "centered-logo" : ""}
                          style={{
                            width: "100%",
                            height: "600px",
                            border: "none",
                          }}
                        ></iframe>
                      ) : (
                        <img
                          src={defaultLogo}
                          className={defaultLogo ? "centered-logo" : ""}
                          alt={template.title}
                        />
                      )}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, md: 8 }} key={template.id}>
                    <Box className="templates__list-info">
                      <h3>{template.title}</h3>
                      <Box mb={1} className="templates__list-meta">
                        <div>
                          <p>
                            <span className="Icon">
                              <UserIcon />
                            </span>{" "}
                            {template.updated_by
                              ?.toLowerCase()
                              .split(" ")
                              .map(
                                (word: any) =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                              )
                              .join(" ")}
                          </p>

                          <p>
                            <span className="Icon">
                              <TimeIcon />
                            </span>{" "}
                            {new Date(template.createdAt).toLocaleString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                              }
                            )}{" "}
                            -{" "}
                            {new Date(template.createdAt).toLocaleString(
                              "en-US",
                              {
                                hour: "2-digit",
                                minute: "2-digit",

                                hour12: true,
                              }
                            )}
                          </p>
                        </div>
                        <div className="templates__list-button">
                          <Tooltip title="Edit" arrow placement="top">
                            <IconButton onClick={() => handleEdit(template)}>
                              {" "}
                              <EditedIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Archived" arrow placement="top">
                            <IconButton
                              onClick={() => handleArchieve(template)}
                            >
                              {" "}
                              <ArchiveOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Grid>
        ))}
        <Dialog
          className="modal"
          open={openArchivePopup}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
        >
          <h2 className="mb-0">
            {" "}
            <span className="Icon red">
              <ArchiveOutlinedIcon />{" "}
            </span>{" "}
            Archived Template
          </h2>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers className="modal_achive--secion">
            <p>
              Please confirm that you would like to archived the template
              <b> {selectedTemplate?.title}</b>
            </p>
            <TextField
              fullWidth
              multiline
              rows={3}
              variant="outlined"
              placeholder="Leave a comment (Optional)"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </DialogContent>
          <DialogActions disableSpacing className="modal_footer--button">
            <Button
              variant="contained"
              color="error"
              onClick={() => handleArchive(selectedTemplate)}
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
              }}
            >
              Archive
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleClose}
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Template;
